module.exports = __webpack_public_path__ + "img/display-knx.dc9e5aef.png";